import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const saveOrderTrackingViewsAndFolders = {
  name: "saveOrderTrackingViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas["order-tracking-shipments"]),
    views: z.array(viewWithIdSchemas["order-tracking-shipments"]),
  }),
  output: zNull(),
};
